<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="name">Name</label>
        <input id="name" type="text" v-model="$parent.supplier.supplier_name">
      </div>

      <div>
        <label for="phone">Phone Number</label>
        <input id="phone" type="text" v-model="$parent.supplier.contact_phone_number">
      </div>

      <div>
        <label for="email">Email</label>
        <input id="email" type="email" v-model="$parent.supplier.email">
      </div>

      <div>
        <label for="mobile_number">Mobile Number</label>
        <input id="mobile_number" type="text" v-model="$parent.supplier.mobile_number">
      </div>

      <div>
        <label for="address">Address</label>
        <input id="address" type="text" v-model="$parent.supplier.address">
      </div>

      <div>
        <label for="nominal_code">Nominal Code</label>
        <input id="nominal_code" type="text" v-model="$parent.supplier.nominal_code">
      </div>

    </div>
    <div class="row" style="padding: 20px;">
      <div class="col-md-12">
        <hr>
        <h4>Bank Details</h4>
        <hr>
        <div class="row">
            <div class="col-md-3">
                <label for="template_type">IBAN number</label>
                <input type="text" id="template-name" placeholder="IBAN number" v-model="$parent.supplier.iban_number">
            </div>
            <div class="col-md-3">
                <label for="template-name">BIC/Swift</label>
                <input type="text" id="template-name" placeholder="BIC/Swift" v-model="$parent.supplier.bic_swift_number">
            </div>
            <div class="col-md-3">
                <label for="template_subject">Account number</label>
                <input id="template_subject" type="text" placeholder="Account number"  v-model="$parent.supplier.account_number">
            </div>
            <div class="col-md-3">
              <label for="template_subject">Sort code</label>
                <input id="template_subject" class="gray-readonly-input" type="text" placeholder="Sort code" v-model="$parent.supplier.sort_code">
            </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-3">
              <label for="template_subject"> Bank name </label>
                <input id="template_subject" class="gray-readonly-input" type="text" placeholder="Bank name" v-model="$parent.supplier.bank_name">
            </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'SupplierFields',
}
</script>
